function addParam(url: string, param: string, value: string): string {
  const urlObj = new URL(url)
  urlObj.searchParams.set(param, value)
  return urlObj.toString()
}

export function buildPickerTriggerUrl(
  base: string,
  key: string,
  value: string
): string {
  if (base.match(/current_ledger_id=[0-9]+/)) {
    return base.replace(
      /current_ledger_id=[0-9]+/g,
      `current_ledger_id=${value}`
    )
  } else {
    return addParam(base, key, value)
  }
}
